export default __webpack_public_path__ + "static/media/Nitro_NLogo.d92507d3.png";